import React from 'react';
import Select from 'react-select';
import '../Filters/Filters.scss';

const SingleSelectFilter = ({
  label,
  options,
  value,
  onChange,
  isClearable,
  placeholder = 'Select...',
  removeZindexStyle = false,
  onBlur
}) => {
  return (
    <div className="filter-control">
      {label && <label className="filter-label">{label}</label>}
      <Select
        classNamePrefix="filter-select"
        options={options}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        isClearable={isClearable}
        placeholder={placeholder}
        menuPlacement="bottom"
        menuShouldBlockScroll={false}
        menuShouldScrollIntoView={true}
        maxMenuHeight={200}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: base => (removeZindexStyle ? { ...base, zIndex: 1056 } : { ...base, zIndex: 9 })
        }}
      />
    </div>
  );
};

export default SingleSelectFilter;

